import { render, staticRenderFns } from "./quest-tag-input.vue?vue&type=template&id=2a81aa1f"
import script from "./quest-tag-input.vue?vue&type=script&lang=js"
export * from "./quest-tag-input.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports